function Plans(){
    return (
        <div className="subscription">
            <h1 className="ws-title">Not available</h1>
        </div>
    );
}

export default Plans;